// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__IRbc5","slider":"styles_slider__jMfap","checkbox":"styles_checkbox__QcSWp","round":"styles_round__1lGY3"};